import { type User } from '../../../../contexts/authContext/types/user.type';
import { APPLICATION_STATUS_TYPE } from '../../../../utils/statusConstants/statusConstants';

export const frcToDoFilter = (user: User | null): any => {
  return {
    status: {
      in: [
        APPLICATION_STATUS_TYPE.FRCSB_ASSESSED,
        APPLICATION_STATUS_TYPE.UNDER_FRCSB,
      ],
    },
  };
};

// applicationsPaginated
export const frcApplicationListFilter = (user: User | null): any => {
  const { userInfo } = user ?? {};
  const {
    netId = '',
    department,
    rightFRCDepartmentChairList = [],
  } = userInfo ?? {};

  return {
    and: [
      netId === ''
        ? null
        : {
            programmeChoice: {
              department: { in: [...rightFRCDepartmentChairList, department] },
            },
          },
      {
        status: {
          nin: [
            APPLICATION_STATUS_TYPE.CREATED,
            APPLICATION_STATUS_TYPE.APPLICATION_FEE_PENDING,
          ],
        },
      },
    ],
  };
};
